export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f0d6c396b36e4fd15fb5a225d586b6ec84502821e&name=fetchTypeahead!'